define('Components/JobWidget/js/models/JobWidgetModel',['underscore', 'app', 'ObjectModel', 'moment'],
    function (_, app, ObjectModel, moment){


    var JobWidgetModel = ObjectModel.extend({
        name:'JobWidgetModel',
        initialize:function() {
            var model = this;

        },
    });

    return JobWidgetModel;

});
